import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import {ErrorContainer, Form} from 'form';

import {t, dt} from 'l10n';

import {sendContactMessage} from 'backend-helpers/contacts';

const STANDBY = 'standby';
const PENDING = 'pending';
const FINISHED = 'finished';

class FormContacts extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            state: STANDBY,
            captchaToken: null,
            captchaError: ''
        };


        this.captchaRef = React.createRef();
        this.captchaWidgetId = null;
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        if (this.state.state === PENDING) return false;

        if (!this.state.captchaToken) {
            this.setState({ captchaError: t('Please confirm you are not a robot') });
            this.resetCaptcha();
            return false;
        }

        this.setState({ state: PENDING });

        sendContactMessage({
            ...formData,
            captcha: this.state.captchaToken
        })
            .then(() => {
                this.resetCaptcha();
                this.setState({ state: FINISHED });
            })
            .catch((error) => {
                setErrors(error.messages || error.message);
                this.resetCaptcha();
                this.setState({ state: STANDBY });
            });
    }

    resetCaptcha() {
        if (!window.turnstile || !this.captchaRef.current) return;

        if (this.captchaWidgetId !== null) {
            window.turnstile.remove(this.captchaWidgetId);
            this.captchaWidgetId = null;
        }

        this.setState({ captchaToken: null });

        this.captchaWidgetId = window.turnstile.render(this.captchaRef.current, {
            sitekey: '0x4AAAAAACYQvImRXMQ5dwGT',
            callback: (token) => {
                this.setState({
                    captchaToken: token,
                    captchaError: ''
                });
            },
            'expired-callback': () => {
                this.setState({ captchaToken: null });
            }
        });
    }

    componentDidMount() {
        const waitForTurnstile = () => {
            if (window.turnstile && this.captchaRef.current) {
                this.resetCaptcha();
                clearInterval(this._turnstileInterval);
            }
        };

        this._turnstileInterval = setInterval(waitForTurnstile, 100);
    }

    componentDidUpdate(prevProps) {
        const wasLoggedIn = prevProps.currentUser.isLoggedIn();
        const isLoggedIn = this.props.currentUser.isLoggedIn();

        if (wasLoggedIn !== isLoggedIn) {
            this.resetCaptcha();
        }
    }


    componentWillUnmount() {
        this.setState({state: STANDBY});
        if (this.captchaWidgetId !== null && window.turnstile) {
            window.turnstile.remove(this.captchaWidgetId);
        }
        clearInterval(this._turnstileInterval);
    }
    
    render() {
        let {currentUser} = this.props;
        let {state} = this.state;

        let contents;
        switch (state) {
            case STANDBY:
            case PENDING:
                let pending = (state === PENDING);
                if (currentUser.isLoggedIn()) {
                    contents = <FormLoggedIn currentUser={currentUser} onSubmit={this.onSubmit} pending={pending} captchaRef={this.captchaRef} captchaError={this.state.captchaError} />;
                } else {
                    contents = <FormUnlogged onSubmit={this.onSubmit} pending={pending} captchaRef={this.captchaRef} captchaError={this.state.captchaError}/>;
                }
                break;
            case FINISHED:
                contents = (
                    <div>
                        <p>{t('Your message has been sent successfully. It will be processed within 24 hours.')}</p>
                        <Link to="/" className="ui-button primary">{t('Return')}</Link>
                    </div>
                );
                break;
        }
    

        return (
            <aside className="form-contacts">
                <div className="content">
                    {contents}
                </div>
            </aside>
        )
    }
}

function FormLoggedIn({currentUser, onSubmit, pending, captchaRef, captchaError}) {
    return (
        <Form className="form-user-contacts" onSubmit={onSubmit}>
            <ErrorContainer data-errorcontainer={true}/>
            <div>
                <p>{t('Email:')}</p>
                <input type="email" name="email" className="ui-text-input" defaultValue={currentUser.email} required/>
            </div>
            <div>
                <p>{t('Message:')}</p>
                <textarea name="message" className="ui-text-input" required/>
            </div>

            <div ref={captchaRef} style={{margin: '10px 0'}}/>


            {captchaError && (
                <div className="form-error" style={{ marginBottom: '10px', color: '#a23330', fontSize: '12px' }}>
                    {captchaError}
                </div>
            )}

            <button type="submit" className={'btn-submit' + (pending ? ' loading' : '')}>
                {dt('alt', 'Send')}
            </button>
        </Form>
    );
}

function FormUnlogged({onSubmit, pending, captchaRef, captchaError}) {
    return (
        <div className="form-user-contacts">
            <Form onSubmit={onSubmit}>
                <ErrorContainer data-errorcontainer={true}/>

                <div>
                    <div>
                        <p>{t('Nick:')}</p>
                        <input name="nick" type="text" className="ui-text-input" required/>
                    </div>
                    {/*<div>*/}
                    {/*    <p>{t('Password:')}</p>*/}
                    {/*    <input name="password" type="password" className="ui-text-input"/>*/}
                    {/*</div>*/}
                </div>
                <div>
                    <div>
                        <p>{t('Email:')}</p>
                        <input name="email" type="email" className="ui-text-input" required/>
                    </div>
                    <div>
                        <p>{t('Status:')}</p>
                        <select name="member_type">
                            <option value="Gratuit">{t('Free')}</option>
                            <option value="XXL">{t('XXL')}</option>
                        </select>
                    </div>
                </div>
                <div>
                    <div>
                        <p>{t('Message:')}</p>
                        <textarea name="message" className="ui-text-input" required/>
                    </div>
                </div>

                <div ref={captchaRef} style={{margin: '10px 0'}}/>


                {captchaError && (
                    <div className="form-error" style={{ marginBottom: '10px', color: '#a23330', fontSize: '12px' }}>
                        {captchaError}
                    </div>
                )}

                <button type="submit" className={'btn-submit' + (pending ? ' loading' : '')}>
                    {dt('alt', 'Send')}
                </button>
            </Form>
        </div>
    )
}

export default FormContacts;


// WEBPACK FOOTER //
// ./src/components/contacts/FormContacts.js